import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Instagram, Facebook, Mail } from "lucide-react";
import api from "@/lib/api";

const DEFAULT_SETTINGS = {
  instagram_url: "https://www.instagram.com/riddhi_drape_the_elegance/",
  facebook_url: "https://www.facebook.com/profile.php?id=61567529159316",
  support_email: "admin@riddhidrape.in",
  support_phone: "+91 86605 15091",
  address: "#83/A, 11th Cross, Mahalaxmi Layout, Bengaluru — 560086",
};

export default function Footer() {
  const [s, setS] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    api.get("/settings/site")
      .then(({ data }) => setS({ ...DEFAULT_SETTINGS, ...data }))
      .catch(() => {});
  }, []);

  return (
    <footer className="bg-[#1C1917] text-stone-200 mt-32">
      <div className="px-6 md:px-12 lg:px-24 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img src="https://customer-assets.emergentagent.com/job_riddhi-elegance/artifacts/8b0yz6uh_ffaab141-db10-4f1b-8d78-dd8685cdd1f1.jpg"
                 alt="Riddhi — Draping the World in Elegance" className="h-24 w-auto object-contain rounded-sm" />
            <p className="mt-8 text-stone-400 font-light leading-relaxed max-w-md">
              A boutique of handloom sarees, contemporary designs, and dresses—crafted with elegance to enhance your natural grace.
            </p>
            <div className="mt-6 space-y-2 text-sm text-stone-400">
              {s.address && <div data-testid="footer-address">{s.address}</div>}
              {s.support_phone && (
                <div><a href={`tel:${s.support_phone.replace(/\s/g, "")}`} className="hover:text-[#D4AF37]" data-testid="footer-phone">{s.support_phone}</a></div>
              )}
              {s.support_email && (
                <div><a href={`mailto:${s.support_email}`} className="hover:text-[#D4AF37]" data-testid="footer-email">{s.support_email}</a></div>
              )}
            </div>
            {s.instagram_url && (
              <a href={s.instagram_url} target="_blank" rel="noreferrer" data-testid="footer-follow-instagram"
                 className="mt-8 inline-flex items-center gap-3 rounded-full border border-[#D4AF37]/60 px-5 py-2.5 text-[11px] tracking-overline uppercase text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#1C1917] transition-colors">
                <Instagram size={16} strokeWidth={1.4} /> Follow us on Instagram
              </a>
            )}
            <div className="flex gap-4 mt-6">
              {s.instagram_url && (
                <a href={s.instagram_url} target="_blank" rel="noreferrer" aria-label="Instagram" className="hover:text-[#D4AF37] transition" data-testid="footer-instagram"><Instagram strokeWidth={1.2} /></a>
              )}
              {s.facebook_url && (
                <a href={s.facebook_url} target="_blank" rel="noreferrer" aria-label="Facebook" className="hover:text-[#D4AF37] transition" data-testid="footer-facebook"><Facebook strokeWidth={1.2} /></a>
              )}
              {s.support_email && (
                <a href={`mailto:${s.support_email}`} aria-label="Email" className="hover:text-[#D4AF37] transition"><Mail strokeWidth={1.2} /></a>
              )}
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="text-[11px] tracking-overline uppercase text-stone-500 mb-5">Shop</div>
            <ul className="space-y-3 text-sm text-stone-300">
              <li><Link to="/shop/sarees" className="hover:text-[#D4AF37]">Sarees</Link></li>
              <li><Link to="/shop/lehengas" className="hover:text-[#D4AF37]">Party Wear</Link></li>
              <li><Link to="/shop/kurtis" className="hover:text-[#D4AF37]">Kurtis</Link></li>
              <li><Link to="/shop/dresses" className="hover:text-[#D4AF37]">Dresses</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[11px] tracking-overline uppercase text-stone-500 mb-5">Discover</div>
            <ul className="space-y-3 text-sm text-stone-300">
              <li><Link to="/bridal" className="hover:text-[#D4AF37]">Bridal</Link></li>
              <li><Link to="/new" className="hover:text-[#D4AF37]">New Arrivals</Link></li>
              <li><Link to="/bestsellers" className="hover:text-[#D4AF37]">Bestsellers</Link></li>
              <li><Link to="/about" className="hover:text-[#D4AF37]">Our Story</Link></li>
              <li><Link to="/contact" className="hover:text-[#D4AF37]">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-overline uppercase text-stone-500 mb-5">Atelier Letter</div>
            <p className="text-sm text-stone-400 mb-4">Receive new drops, care notes, and private previews.</p>
            <form onSubmit={(e) => e.preventDefault()} className="flex gap-3">
              <input type="email" placeholder="Your email"
                     className="bg-transparent border-b border-stone-700 focus:border-[#D4AF37] outline-none px-0 py-2 text-sm flex-1"
                     data-testid="newsletter-input" />
              <button className="text-[11px] tracking-overline uppercase text-[#D4AF37] hover:text-white transition" data-testid="newsletter-submit">Join</button>
            </form>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-stone-800 flex flex-col md:flex-row justify-between text-xs text-stone-500 gap-3">
          <div>© {new Date().getFullYear()} Riddhi. Crafted with care in India.</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-[#D4AF37]">Privacy</a>
            <a href="#" className="hover:text-[#D4AF37]">Terms</a>
            <a href="#" className="hover:text-[#D4AF37]">Shipping & Returns</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
